import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Branch from "../../../containers/modules/master/branch";

export default function BranchRoute( props ) {
    const {authUser}=props
    return (
        <Route
            path="branch"
            index
            element={
            <AccessControl
                name="Branch List"
                auth={authUser}
                component={() => <Branch authUser={authUser} />}
            />
            }
        />
    )
}